import React from 'react';
import { FormControl } from '@material-ui/core';
import moment from 'moment';

const formatDate = (isoString) => {
  return moment(isoString)
    .utc()
    .format('DD/MM/YYYY');
};

const DateLabel = ({ id, label, value }) => {
  return (
    <FormControl>
      <label htmlFor={`label-${id}`}>
        <b>{label}</b>
      </label>
      <div id={id}>{value ? formatDate(value) : '-'}</div>
    </FormControl>
  );
};

export default DateLabel;
